import React from 'react';

import NavigationFull from './Full';

const Navigation = ({ variant, ...props }) => {
  switch (variant) {
    default:
      return <NavigationFull {...props} />;
  }

};

export default Navigation;
